import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class MessageBoardService {
	public static messageBoardGetByFilter() {
		return Http.axios().get('/api/MessageBoard/getall', { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardSave(input: any) {
		return input.messageBoard.messageBoardId > 0 ?
			Http.axios().put('/api/MessageBoard/update', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } }) 
			.then((res: any) => {
				return res;
			}).catch((e: any) => {
				return e.response;
			})
			:
			Http.axios().post('/api/MessageBoard/add', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				});
	}

	public static messageBoardGetDetail(id: any) {
		return Http.axios().get('/api/MessageBoard/details/' + id, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardDelete(id: any) {
		return Http.axios().delete('/api/MessageBoard/delete/' + id, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetReport(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('api/MessageBoard/getreport', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetTopicByFilter(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('api/Topic/getbyfilter', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardTopicDelete(id: any) {
		return Http.axios().delete('/api/Topic/delete/' + id, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardTopicRestore(id: any) {
		return Http.axios().put('/api/Topic/restore', { topic: { topicId: id } }, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetPostByFilter(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Post/getbyfilter', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetAlert(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('api/ReportedMessage/getreportedposts', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardPostDelete(id: any) {
		return Http.axios().delete('/api/Post/delete/' + id, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardPostRestore(id: any) {
		return Http.axios().put('/api/Post/restore', { post: { postId: id } }, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardPostFlag(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('api/ReportedMessage/flagpost', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardPostAuthorization(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('api/ReportedMessage/approverejectpost', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetReportType() {
		return Http.axios().get('/api/MessageReportType/getall', { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetCountByYear(input) {
		return Http.axios().post('/api/MessageBoard/GetBoardMessagesCountByYear', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetByUserId(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/MessageBoard/getDashboardMessagesByUserId', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static messageBoardGetChannelMessageByUserId(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/MessageBoard/getDashboardChannelMessagesByUserId', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}